<div class="article">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner" [fontSize]="'long-word'"></app-banner-header>
    </div>
    <div class="page-able mt-4 mb-5">
        <div class="container">
            <div class="row">
                <div class="col-md-12 px-4">
                    <div class="section-articles">
                        <div class="row" *ngIf="dataArticle?.length != 0">
                            <!-- article -->
                            <div class="col-lg-4 col-md-6 py-md-3 py-2" 
                                *ngFor="let article of dataArticle"
                                data-aos="fade-up">
                                <app-card-article [dataArticle]="article" [type]="article.category.title"></app-card-article>
                            </div>
                        </div>
                        <div style="height: 300px" 
                            *ngIf="dataArticle?.length == 0"
                            class="d-flex w-100 align-items-center justify-content-center">
                            <h6>{{ isLang?.noData }}</h6>
                        </div>
                    </div>
                    <div class="row mt-4" *ngIf="btnLoad">
                        <div class="col-lg-3 col-md-4 col-9 mx-auto">
                            <button [disabled]="textLoad == 'Loading...'"
                                    class="btn more red-btn w-100" 
                                    (click)="getMore()">
                                    {{ textLoad }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>